const QuestionnaireType = Object.freeze({
  ADULT: 'adult',
  ADOLESCENT: 'adolescent'
})

export { QuestionnaireType }
